import { toImageSrc } from "@/lib/utils"
import { Button, Modal } from "antd"
import Image from "next/image"
import { useEffect, useState } from "react"
import { MediaData } from "../../../../lib/config/types"
import { DefaultImage, Media } from "../../../../lib/external-components"

export const MediaSelect = ({ value, onChange }: any) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [url, setUrl] = useState(value || "")
  const [imageError, setImageError] = useState(false)

  useEffect(() => {
    const isValueUrl = typeof value === 'string' && (value.startsWith('http') || value.startsWith('/'))
    if (isValueUrl) {
      setUrl(value)
    } else if (!value) { setUrl("") }
    setImageError(false)
  }, [value])

  const openModal = () => {
    setIsModalOpen(true)
  }

  const handleSelectMedia = (media: MediaData) => {
    if (media) {
      setUrl(media.url)
      onChange(media.url)
      setIsModalOpen(false)
      setImageError(false)
    }
  }

  const handleCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleImageError = () => {
    setImageError(true)
  }

  const imageSrc = url ? toImageSrc(url) : DefaultImage
  const displaySrc = imageError ? DefaultImage : imageSrc

  return (
    <div>
      <div className="flex flex-col gap-2">
        <input type="text" value={url} onChange={e => onChange(e.target.value)} placeholder="URL Path" readOnly />
        <div className="relative cursor-pointer group" onClick={() => openModal()}>
          <Image
            src={displaySrc}
            alt="Logo"
            className="rounded-lg max-h-96 cursor-pointer transition duration-300 ease-in-out group-hover:blur-sm overflow-hidden"
            width={300}
            height={300}
            onError={handleImageError}
          />
          <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition duration-300 ease-in-out">
            <span className="text-white text-xl font-semibold drop-shadow-md">
              {url ? "Change Media" : "Select Media"}
            </span>
          </div>
        </div>

        <Button
          onClick={() => openModal()}
          type="default"
          variant="outlined"
          className="bg-blue text-white p-4 border-[1px] border-blue rounded-[3px] hover:bg-blue-800 hover:text-white duration-300 my-2"
        >
          Select Image
        </Button>
      </div>
      <Modal
        open={isModalOpen}
        title={<span className="ml-4">Select Media</span>}
        onCancel={handleCloseModal}
        style={{ top: 20 }}
        width="95%"
        footer={null}
      >
        <div>
          <Media isOpenModal={true} onSelectMedia={media => handleSelectMedia(media as MediaData)} />
        </div>
      </Modal>
    </div>
  )
}
